import React from 'react';
import { useTranslation } from 'react-i18next';
import SidebarDialog from '../molecules/SidebarDialog';
import CuppingComments from '../organisms/CuppingComments/CuppingComments';
var CuppingCommentsDialog = function (_a) {
    var editable = _a.editable, orderedItem = _a.orderedItem, onChange = _a.onChange;
    var t = useTranslation().t;
    var _b = React.useState(''), title = _b[0], setTitle = _b[1];
    var _c = React.useState(''), subTitle = _c[0], setSubTitle = _c[1];
    var _d = React.useState(), selectedUser = _d[0], setSelectedUser = _d[1];
    var _e = React.useState(false), showCuppingCommentForm = _e[0], setShowCuppingCommentForm = _e[1];
    var backgroundColor = React.useMemo(function () { return (showCuppingCommentForm ? '#fff' : '#eee'); }, [showCuppingCommentForm]);
    var handleBack = React.useMemo(function () {
        if (!selectedUser && !showCuppingCommentForm)
            return undefined;
        return function () {
            handleSelectedUserChange(undefined);
            handleShowForm(false);
        };
    }, [selectedUser, showCuppingCommentForm]);
    var handleClose = React.useCallback(function () {
        handleBack && handleBack();
        onChange(undefined);
    }, [onChange, handleBack]);
    React.useEffect(function () {
        var _a;
        setTitle(t('pages.cuppingComments.title'));
        setSubTitle(((_a = orderedItem === null || orderedItem === void 0 ? void 0 : orderedItem.offer) === null || _a === void 0 ? void 0 : _a.lotNumber) || '');
    }, [orderedItem]);
    var handleSelectedUserChange = React.useCallback(function (user) {
        var _a;
        setSelectedUser(user);
        if (!user) {
            setSubTitle(((_a = orderedItem === null || orderedItem === void 0 ? void 0 : orderedItem.offer) === null || _a === void 0 ? void 0 : _a.lotNumber) || '');
            return;
        }
        setTitle(user.roaster
            ? "".concat(user.roaster.storeName || '', " ").concat(t('fullname', user.roaster) || '')
            : user.name);
        setSubTitle('');
    }, [t, orderedItem]);
    var handleShowForm = React.useCallback(function (showForm) {
        setShowCuppingCommentForm(showForm);
        setTitle(t("pages.".concat(showForm ? 'createCuppingComment' : 'cuppingComments', ".title")));
    }, [t, orderedItem]);
    return (React.createElement(SidebarDialog, { title: title, subTitle: subTitle, open: Boolean(orderedItem), onClose: handleClose, onBack: handleBack, contentProps: {
            id: 'comment-dialog-content',
            style: {
                padding: 0,
                backgroundColor: backgroundColor,
            },
        }, maxWidth: "xs" },
        React.createElement(CuppingComments, { editable: editable, orderedItem: orderedItem, selectedUser: selectedUser, showCuppingCommentForm: showCuppingCommentForm, onSelectedUserChange: handleSelectedUserChange, onShowForm: handleShowForm, onOrderedItemChange: onChange, onClose: handleClose })));
};
export default CuppingCommentsDialog;
